<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo" >
        <!-- <vuexy-logo /> -->
        <b-img
          class="d-none d-sm-block"
          :src="require('@/assets/logo-taobao/Profile.jpg')"
          fluid
          width="50px"
          height="30px"
        >
        </b-img>
        <h2 class="brand-text text-primary ml-1 mt-1 d-none d-sm-block">
          TAOBAO2YOU
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title >
            <h1 class="font-weight-bolder">อีกนิดนะคะ ใกล้เสร็จแล้ว</h1>
            <small>กรุณากรอกข้อมูลเพิ่มเติม เพื่อให้สะดวกในการสั่งของค่ะ</small>
            <h2 class="pt-3">Facebook Profile</h2>
            <span class="pr-2">
              <b-spinner v-if="this.loadImg == false" label="Loading..." variant="primary" />
              <b-img v-else :src="this.infoFacebook.picture.data.url"></b-img>
            </span>
            <span>{{this.infoFacebook.name}}</span>
            <h2 class="pt-1">ข้อมูลส่วนตัวเพิ่มเติม</h2>
          </b-card-title>

          <!-- form -->
          <validation-observer
            ref="registerForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-register-form mt-2"
              @submit.prevent="btnLogin"
            >
              <!-- firstname -->
              <b-form-group
                label="ชื่อ :"
                label-for="register-firstname"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Firstname"
                  vid="firstname"
                  rules="required"
                >
                  <b-form-input
                    id="register-firstname"
                    v-model="firstname"
                    name="register-firstname"
                    :state="errors.length > 0 ? false:null"
                  />
                  <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                  <small class="text-danger">{{ errors[0] ? 'กรุณากรอกชื่อ' : null }}</small>
                </validation-provider>
              </b-form-group>

              <!-- lastname -->
              <b-form-group
                label="นามสกุล :"
                label-for="register-lastname"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Lastname"
                  vid="lastname"
                  rules="required"
                >
                  <b-form-input
                    id="register-lastname"
                    v-model="lastname"
                    name="register-lastname"
                    :state="errors.length > 0 ? false:null"
                  />
                  <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                  <small class="text-danger">{{ errors[0] ? 'กรุณากรอกนามสกุล' : null }}</small>
                </validation-provider>
              </b-form-group>

              <!-- phone -->
              <b-form-group
                label="เบอร์โทรศัพท์ :"
                label-for="register-phone"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Phone"
                  vid="phone"
                  rules="required"
                >
                  <b-form-input
                    id="register-phone"
                    v-model="phone"
                    name="register-phone"
                    :state="errors.length > 0 ? false:null"
                  />
                  <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                  <small class="text-danger">{{ errors[0] ? 'กรุณากรอกเบอร์โทรศัพท์' : null }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group
                label="Email :"
                label-for="register-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="register-email"
                    v-model="userEmail"
                    name="register-email"
                    :state="errors.length > 0 ? false:null"
                  />
                  <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                  <small class="text-danger">{{ errors[0] ? 'กรุณากรอกEmail' : null }}</small>
                </validation-provider>
              </b-form-group>

              <!-- contact -->
              <b-form-group
                label="ต้องการ :"
                label-for="register-contact"
              >
                <b-form-radio-group
                  v-model="needContact"
                  :options="contactOptions"
                  name="radio-validation"
                >
                </b-form-radio-group>
                <small v-if="valContact == false" class="text-danger">กรุณาเลือกความต้องการ</small>
              </b-form-group>

              <!-- line id -->
              <b-form-group
                label="LineID :"
                label-for="register-lineID"
              >
                <b-form-input
                  id="register-lineId"
                  v-model="lineId"
                  name="register-lineId"
                />
              </b-form-group>

              <b-button
                variant="primary"
                block
                type="submit"
                :disabled="invalid"
              >
                ยืนยัน
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> เข้าสู่ระบบ
            </b-link>
          </p>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup,
  BInputGroupAppend, BImg, BCardTitle, BCardText, BFormRadioGroup, BSpinner
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import {token_api, header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  components: {
    VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormRadioGroup,
    BSpinner,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      name: '',
      firstname: '',
      lastname: '',
      phone: '',
      userEmail: '',
      needContact: null,
      lineId: '',
      contactOptions: [
        { text: 'ต้องการให้พนักงานติดต่อกลับเพื่ออธิบายวิธีการสั่งสินค้าเพิ่มเติม', value: true },
        { text: 'ต้องการหาข้อมูลด้วยตัวเองก่อน', value: false },
      ],
      valContact: true,
      username: '',
      password: '',
      rePassword: '',
      valPassword: true,
      sideImg: require('@/assets/images/pages/register-v2.svg'),
      // validation
      required,
      email,

      infoFacebook: [],
      loadImg: false,

      parentID: null
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const urlCode = await urlParams.get('id')
    this.parentID = urlCode
    this.getInfoFacebook()
  },

  methods: {
    async getInfoFacebook(){
      var profile = await JSON.parse(localStorage.getItem('resFacebook'))
      this.userEmail = profile.email
      this.infoFacebook = await profile
      this.loadImg = true
    },
    async btnLogin() {
      if (this.needContact == null) {
        this.valContact = false
      } else {
        var profile = []
        var sToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.GAO0TlWsHDaP_KImlaG6MomhnomjHj5xTWMkrfoNUmw"
        var rToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.FoUDDNh6hBlWHtHKsagslOFU20v9aYVAhDX9SqKAajE"
        let response = await axios.post(taobaoService_dotnet  + 'app/Customer/facebook-sign-up-web', {
          "facebookID": this.infoFacebook.id,
          "facebookEmail": this.infoFacebook.email,
          "facebookName": this.infoFacebook.name,
          "facebookPic": this.infoFacebook.picture.data.url,
          "email": this.userEmail,
          "lineID": this.lineId,
          "phone": this.phone,
          "isNeedContact": this.needContact,
          "firstName": this.firstname,
          "lastName": this.lastname,
          "parentID": this.parentID
        },
        { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }})
        if ( response.data.message == 'success') {
          await profile.push({
            'data': response.data,
            'role': 'facebook',
            'ability': [
              {action: "manage", subject: "normal"},
              {action: "manage", subject: "Auth"},
              {action: "manage", subject: response.data.customerInfo.isSeeBankAccount == true ? "high1" : "normal" },
              {action: "manage", subject: response.data.customerInfo.isBlockWithdraw == false ? "high2" : "normal" },
            ]
          })
          useJwt.setToken(sToken)
          useJwt.setRefreshToken(rToken)
          localStorage.setItem('userData', JSON.stringify(profile[0]))
          localStorage.setItem('cusId', JSON.stringify(profile[0].data.customerInfo.customerID))
          this.$ability.update(profile[0].ability)

          this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', profile[0].data.customerInfo.quantityCart)

          this.$router.replace(getHomeRouteForLoggedInUser(profile[0].role))

          localStorage.removeItem("userFacebook");
          localStorage.removeItem("resFacebook");
        } else if (response.data.customerInfo ==  null) {
          this.$swal({
            icon: 'warning',
            title: 'ไม่สำเร็จ',
            text: response.data.message,
            confirmButtonText: 'เข้าใจแล้ว',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        }
      }
    }
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
